import axios from 'axios';
import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let scheduleCache = null;
let inflight = null;

export function invalidateSchedule() {
  scheduleCache = null;
  inflight = null;
}

export async function fetchSchedule() {
  if (scheduleCache) return scheduleCache;
  if (!inflight) {
    inflight = axios.get(`${API}/schedule`).then((res) => {
      scheduleCache = res.data;
      return scheduleCache;
    });
  }
  return inflight;
}

export function useSchedule() {
  const [schedule, setSchedule] = useState(scheduleCache);
  const [loading, setLoading] = useState(!scheduleCache);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchSchedule()
      .then((data) => {
        if (alive) {
          setSchedule(data);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (alive) {
          setError(e);
          setLoading(false);
        }
      });
    return () => {
      alive = false;
    };
  }, []);

  return { schedule, loading, error };
}

export async function createBooking({ name, email, classSlot }) {
  const res = await axios.post(`${API}/bookings`, { name, email, class_slot: classSlot });
  invalidateSchedule();
  return res.data;
}

export async function sendContact({ name, email, message }) {
  const res = await axios.post(`${API}/contact`, { name, email, message });
  return res.data;
}
